angular.module 'zc.core'

# This is to convert date into object with separate date/time properties
# to be used with dateTimePicker
# example
# Date => {
#       date: date in jstime (without minute part)
#       time: minutes of current day
#       date_raw: date as string
#       time_raw: HH:mm as string
# }
.filter 'dateToDateObj', ($filter, $translate) ->
  return (date) ->
    date_obj = {}
    if date
      date_obj.date = moment(date).startOf('day').valueOf()
      date_obj.time = moment(date).diff(moment(date_obj.date)) / 60 / 1000
      # set date_raw here because date_time_picker won't work otherwise
      date_obj.date_raw = moment(date_obj.date).format($translate.instant('sharedModules.dateTimeFormats.filters.dateToDateObj.format'))
      date_obj.time_raw = moment().startOf('day').add(date_obj.time, 'minutes').format('HH:mm')
    else
      date_obj.date = null
      date_obj.time = null

    date_obj



// WEBPACK FOOTER //
// ../app_shared/src/shared_modules/core/filters/date_to_date_obj.filter.js.coffee